import { Youtube } from "lucide-react";
import Reveal from "./Reveal";

const VIDEO_ID = "vTmj7wZiaxg";
const EMBED_URL = `https://www.youtube-nocookie.com/embed/${VIDEO_ID}?rel=0&modestbranding=1&playsinline=1`;

export default function YouthInActionVideo() {
  return (
    <section
      data-testid="youth-in-action-section"
      className="border-t border-white/10 py-20 bg-[#0A0A0A]"
    >
      <div className="container-fld">
        <Reveal>
          <div className="flex items-center justify-center gap-3 mb-3">
            <Youtube
              className="w-6 h-6 text-[#7CFF00]"
              aria-hidden="true"
              data-testid="youth-video-icon"
            />
            <span className="overline">// Field Footage</span>
          </div>
          <h3
            data-testid="youth-in-action-title"
            className="font-tactical text-3xl md:text-5xl font-bold uppercase text-white tracking-tight text-center leading-none"
          >
            Youth Preparedness <span className="text-[#7CFF00]">In Action</span>
          </h3>
        </Reveal>

        <Reveal delay={120}>
          <div className="mt-10 mx-auto max-w-sm md:max-w-md">
            {/* Video frame — vertical 9:16 to match YouTube Shorts */}
            <div
              data-testid="youth-video-frame"
              className="relative bg-black border border-[#7CFF00]/40 shadow-[0_0_36px_rgba(124,255,0,0.22)] hover:shadow-[0_0_56px_rgba(124,255,0,0.4)] hover:border-[#7CFF00] transition-all duration-500 group"
            >
              {/* corner ticks */}
              <span className="absolute -top-px -left-px w-5 h-5 border-t-2 border-l-2 border-[#7CFF00] pointer-events-none z-10" />
              <span className="absolute -top-px -right-px w-5 h-5 border-t-2 border-r-2 border-[#7CFF00] pointer-events-none z-10" />
              <span className="absolute -bottom-px -left-px w-5 h-5 border-b-2 border-l-2 border-[#7CFF00] pointer-events-none z-10" />
              <span className="absolute -bottom-px -right-px w-5 h-5 border-b-2 border-r-2 border-[#7CFF00] pointer-events-none z-10" />

              <div className="aspect-[9/16] w-full">
                <iframe
                  data-testid="youth-video-iframe"
                  src={EMBED_URL}
                  title="Frontline Defense — Youth Preparedness In Action"
                  loading="lazy"
                  allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  className="w-full h-full"
                />
              </div>
            </div>

            <p
              data-testid="youth-video-caption"
              className="mt-6 text-center text-zinc-400 text-sm md:text-base leading-relaxed italic"
            >
              Real training. Real discipline. Real confidence-building through
              safe, supervised instruction.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
